export default "__VITE_ASSET__8Hhdv_hd__"